import { ShieldCheck } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const login = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16">
      <div className="dg-card rounded-2xl p-8 text-center">
        <div className="w-12 h-12 rounded-lg bg-cyan-500/10 border border-cyan-500/40 grid place-items-center mx-auto">
          <ShieldCheck className="w-6 h-6 text-cyan-400" />
        </div>
        <h1 className="font-display text-2xl font-bold mt-4">Admin sign-in</h1>
        <p className="text-slate-400 text-sm mt-2">For Dr.Gadget staff only. Sign in with Google to manage bookings and tickets.</p>
        <button onClick={login} className="dg-btn-primary rounded-full px-6 py-3 text-sm mt-6 w-full" data-testid="admin-google-signin">
          Continue with Google
        </button>
        <p className="text-xs text-slate-500 mt-4">Only whitelisted accounts have admin access.</p>
      </div>
    </div>
  );
}
